import { linkToAssignmentsOverviewPage } from "../../links";

export function linkToShareMultipleAssignment(classId?: string) {
  return `${linkToAssignmentsOverviewPage(classId)}/share`;
}
